// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] || chunkId) + "-" + {"589":"6b07b7bd1e875db3413f","678":"b3932ad728a2ae2aa842","883":"47c84b2d72c2b5d3985c"}[chunkId] + ".js";
};